import { Ditto } from '@ow/ditto-core'
import * as DtText from '../fields/text'
import * as DtNumber from '../fields/number'
import * as DtDropSelect from '../fields/dropselect'
import * as DtStandard from '../fields/standard'
import * as DtArea from '../fields/area'
import * as DtGeolocation from '../fields/geolocation'
import * as DtMedia from '../fields/media'

export const ditto = new Ditto()
console.log(DtArea)
ditto.registeWidget('text', {
  render: DtText.Render,
  config: DtText.config,
})

ditto.registeWidget('number', {
  render: DtNumber.Render,
  config: DtNumber.config,
})
ditto.registeWidget('dropSelect', {
  render: DtDropSelect.Render,
  config: DtDropSelect.config,
})
ditto.registeWidget('standard', {
  render: DtStandard.Render,
  config: DtStandard.config,
})
ditto.registeWidget('area', {
  render: DtArea.Render,
  config: DtArea.config,
})
ditto.registeWidget('geolocation', {
  render: DtGeolocation.Render,
  config: DtGeolocation.config,
})
ditto.registeWidget('media', {
  render: DtMedia.Render,
  config: DtMedia.config,
})
export default ditto
